module.exports = __webpack_public_path__ + "img/film.1cee86ab.svg";